var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvAccessoriesBooking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.242,
    height: 69.242,
    viewBox: "0 0 69.242 69.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EV_accessories_Booking",
    "data-name": "EV accessories Booking",
    transform: "translate(2.422 17.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(-2.422 -17.871)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.242,
    height: 69.242,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 66.242,
    height: 66.242,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M89.5,22.953h4.717v8.634H89.5Z",
    transform: "translate(-36.454 -20.479)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M14.328,56.018a1.192,1.192,0,0,1-1.649-.322h-.008a1.169,1.169,0,0,1-.478.7,1.2,1.2,0,0,1-1.649-.313v-.016a1.237,1.237,0,0,1-.478.709,1.2,1.2,0,0,1-1.649-.313l-.066-.091-2.07,1.4L4.737,65.89H1.562l1.773-9.319a1.559,1.559,0,0,1,.652-1l2.606-1.765-.058-.091a1.183,1.183,0,0,1,.313-1.649,1.168,1.168,0,0,1,.833-.181H7.673a1.19,1.19,0,0,1,.313-1.658,1.216,1.216,0,0,1,.833-.19H8.811A1.189,1.189,0,1,1,10.774,48.7l3.859,5.682a1.184,1.184,0,0,1-.313,1.649Z",
    transform: "translate(5.071 -32.392)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M37.088,28.454l-1.031-1.517-9.558,6.5,2.07,1.253a.876.876,0,0,0,.957-.025l7.331-4.981a.878.878,0,0,0,.231-1.229Z",
    transform: "translate(-6.705 -22.361)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M53.218,18.266H39.528a1.776,1.776,0,0,0-1.773,1.773l-2.622,1.806,2.02,2.985a.887.887,0,0,1-.231,1.229l-9.739,6.614a.892.892,0,0,1-.957.025l-3.736-2.26-.28.181a1.785,1.785,0,0,0-.47,2.474l4.288,6.3a1.781,1.781,0,0,0,2.466.47l.858-.586a1.223,1.223,0,0,0,.536-1.064,1.4,1.4,0,0,1,1.987-1.352,1.2,1.2,0,0,0,1.188-.107,1.223,1.223,0,0,0,.536-1.064,1.4,1.4,0,0,1,1.987-1.352,1.223,1.223,0,0,0,1.188-.107,1.2,1.2,0,0,0,.536-1.064,1.391,1.391,0,0,1,.619-1.237,1.377,1.377,0,0,1,.783-.247,1.414,1.414,0,0,1,.586.132,1.21,1.21,0,0,0,.866.041H53.2a1.769,1.769,0,0,0,1.773-1.765V20.039A1.77,1.77,0,0,0,53.2,18.266Zm-2.7,5.863-3.167,5.706a.316.316,0,0,1-.594-.165l.124-2.895a.319.319,0,0,0-.322-.33H43.957a.314.314,0,0,1-.272-.47l3.158-5.7a.316.316,0,0,1,.594.165l-.115,2.886a.312.312,0,0,0,.313.33h2.614a.314.314,0,0,1,.272.47Z",
    transform: "translate(-4.312 -18.266)",
    fill: "#00b26b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvAccessoriesBooking);
export default __webpack_public_path__ + "static/media/EVAccessoriesBooking.ff01ec5c41dd173ae18e1e2a6cb8f814.svg";
export { ForwardRef as ReactComponent };